import { React, useContext, useEffect, useState } from "react";
import MinimizedObjectSection from "./MinimizedObjectSection";
import expand from "../../assets/icons/expandDedault.png";
import closeBtn from "../../assets/icons/closeSm.png";
import { AppContext } from "../../Context/Context";
import useMinimizedModalFeature from "../../hooks/useMinimizedModalFeature";
import { useDispatch } from "react-redux";
import { setFollowingLgvList } from "../../store/plantSlice";

const MinimizedWebObjects = () => {
  const {
    minimizedWebObjectsList,
    setMinimizedWebObjectsList,
    setIsMarkerPopupOpen,
    setSelectedMarkerData,
    setSelectedMarkerType
  } = useContext(AppContext);

  const { feature } = useMinimizedModalFeature();
  const dispatch = useDispatch();

  const [isLgvListOpened, setIsLgvListOpened] = useState(false);
  const [isProductionLineListOpened, setIsProductionLineListOpened] =
    useState(false);
  const [isDockListOpened, setIsDockListOpened] = useState(false);
  const [isLgvFollowingListOpened, setIsLgvFollowingListOpened] =
    useState(false);

  const maximizeModal = (item, type) => {
    setSelectedMarkerData(item);
    setSelectedMarkerType(type);
    setIsMarkerPopupOpen(true);
  };

  useEffect(() => {
    if (minimizedWebObjectsList[feature].lgv.length === 0) {
      setIsLgvListOpened(false);
    }
  }, [minimizedWebObjectsList, feature]);

  //LGV Modal Handlers
  const minimizeLgvsHandler = () => {
    setIsLgvListOpened(!isLgvListOpened);
  };

  const minimizeFollowingLGVsHandler = () => {
    setIsLgvFollowingListOpened(!isLgvFollowingListOpened);
  };

  const closeParticularLgvModal = (item) => {
    let localLgvList = minimizedWebObjectsList[feature].lgv;
    let indexOfItemToDelete = localLgvList.indexOf(item);
    localLgvList.splice(indexOfItemToDelete, 1);
    setMinimizedWebObjectsList((prev) => ({
      ...prev,
      [feature]: {
        ...prev[feature],
        lgv: localLgvList
      }
    }));
    if (localLgvList.length === 0) {
      setIsLgvListOpened(false);
    }
  };

  //Dock Door Handlers
  const minimizeDocksHandler = () => {
    setIsDockListOpened(!isDockListOpened);
  };

  const closeParticularDockModal = (item) => {
    let localDocksList = minimizedWebObjectsList[feature].docks;
    let indexOfItemToDelete = localDocksList.indexOf(item);
    localDocksList.splice(indexOfItemToDelete, 1);
    setMinimizedWebObjectsList((prev) => ({
      ...prev,
      [feature]: {
        ...prev[feature],
        docks: localDocksList
      }
    }));
    if (localDocksList.length === 0) {
      setIsDockListOpened(false);
    }
  };

  //Production Line Handlers
  const minimizeProductionLineHandler = () => {
    setIsProductionLineListOpened(!isProductionLineListOpened);
  };


  const closeParticularProductionLineModal = (item) => {
    const localProductionLineList =
      minimizedWebObjectsList[feature].productionLine;

    const updatedList = localProductionLineList.filter(
      (i) => i?.LINE_NAME !== item?.LINE_NAME
    );

    setMinimizedWebObjectsList((prev) => ({
      ...prev,
      [feature]: {
        ...prev[feature],
        productionLine: updatedList
      }
    }));
    if (updatedList.length === 0) {
      setIsProductionLineListOpened(false);
    }
  };

  const closeAllMinimizedModals = (type) => {
    if (type === "lgv") {
      setMinimizedWebObjectsList((prev) => ({
        ...prev,
        [feature]: {
          ...prev[feature],
          lgv: []
        }
      }));
      minimizeLgvsHandler();
    } else if (type === "dock") {
      setMinimizedWebObjectsList((prev) => ({
        ...prev,
        [feature]: {
          ...prev[feature],
          docks: []
        }
      }));
      minimizeDocksHandler();
    } else if (type === "productionLine") {
      setMinimizedWebObjectsList((prev) => ({
        ...prev,
        [feature]: {
          ...prev[feature],
          productionLine: []
        }
      }));
      minimizeProductionLineHandler();
    } else if (type === "followingLgv") {
      dispatch(setFollowingLgvList({ feature, list: [] }));
      minimizeFollowingLGVsHandler();
    }
  };

  const sectionsConfig = [
    {
      title: "LGVs",
      type: "lgv",
      items: minimizedWebObjectsList[feature].lgv,
      isOpened: isLgvListOpened,
      toggleHandler: minimizeLgvsHandler,
      maximizeModal,
      closeAllModals: closeAllMinimizedModals,
      closeItemModal: closeParticularLgvModal,
      getItemLabel: (item) => `LGV ${item.vehicleNumber}`,
      itemKey: "vehicleNumber",
      containerWidthClass: "minimized-objects-expanded-view-lgv-width"
    },
    {
      title: "Dock Doors",
      type: "dock",
      items: minimizedWebObjectsList[feature].docks,
      isOpened: isDockListOpened,
      toggleHandler: minimizeDocksHandler,
      maximizeModal,
      closeAllModals: closeAllMinimizedModals,
      closeItemModal: closeParticularDockModal,
      getItemLabel: (item) => `Door ${Number(item[0].dock.split(".")[1])}`,
      containerWidthClass: "minimized-objects-expanded-view-dock-width"
    },
    {
      title: "Production Lines",
      type: "productionLine",
      items: minimizedWebObjectsList[feature].productionLine,
      isOpened: isProductionLineListOpened,
      toggleHandler: minimizeProductionLineHandler,
      maximizeModal,
      closeAllModals: closeAllMinimizedModals,
      closeItemModal: closeParticularProductionLineModal,
      getItemLabel: (item) => `Line ${item.LINE_NAME}`,
      itemKey: "LINE_NAME",
      containerWidthClass:
        "minimized-objects-expanded-view-production-line-width"
    }
  ];

  return minimizedWebObjectsList[feature].lgv.length === 0 &&
    minimizedWebObjectsList[feature].docks.length === 0 &&
    minimizedWebObjectsList[feature].productionLine.length === 0 ? (
    <></>
  ) : (
    <div className="minimized-objects-wrapper">
      <div className="minimized-objects-container">
        {sectionsConfig.map((section) => (
          <MinimizedObjectSection
            key={section.type}
            {...section}
            expandIcon={expand}
            closeIcon={closeBtn}
          />
        ))}
      </div>
    </div>
  );
};

export default MinimizedWebObjects;
